import React, { useEffect, useState } from "react";
import { useParams, Link } from "react-router-dom";
import { notify } from "../App";

// Empty string / invalid -> 0 (never NaN)
const num = (v) => {
  const n = Number(v);
  return isNaN(n) ? 0 : n;
};

const RentalDetail = () => {

  const { id } = useParams();

  const [data, setData] = useState(null);

  // Active billing tab
  const [activeTab, setActiveTab] = useState("initial");

  // Generic extra-charge form (transport / labour / additional)
  const [chargeForm, setChargeForm] = useState({
    type: "transport",
    amount: "",
    note: "",
    entry_date: ""
  });

  const [returnData, setReturnData] = useState([]);

  const [returnedAmount, setReturnedAmount] = useState("");

  const [receivedAmount, setReceivedAmount] = useState("");

  const [settlementNote, setSettlementNote] = useState("");

  const [creditAmount, setCreditAmount] = useState("");

  const [paymentNote, setPaymentNote] = useState("");

  const [showReturn, setShowReturn] = useState({});

  const [showRecover, setShowRecover] = useState({});

const [recoverData, setRecoverData] = useState({});

  const [showExtend, setShowExtend] = useState({});

  // =========================================
  // ✅ ADD PRODUCT (reuses Create Rental fields)
  // =========================================

  const [products, setProducts] = useState([]);

  const [showAddProduct, setShowAddProduct] =
    useState(false);

  const [newProduct, setNewProduct] = useState({
    product_id: "",
    quantity: "",
    rent: 0,
    rent_date: "",
    return_date: "",
    transport_amount: "",
    transport_note: "",
    labour_amount: "",
    labour_note: ""
  });

  // =========================================
  // ✅ FETCH DATA
  // =========================================

  const fetchData = () => {

    fetch(`/api/rental-details/${id}`)
      .then(res => res.json())
      .then(res => {

         console.log("ITEMS", res.items);

        setData(res);

        const initial = res.items.map(item => ({
          rental_item_id: item.rental_item_id,
         
          name: item.name,
          quantity: Number(item.quantity) || 0,

          // Persisted (already returned / lost / damaged) — for display
          db_returned_quantity:
            Number(item.returned_quantity) || 0,
          db_lost_quantity:
            Number(item.lost_quantity) || 0,
          db_damage_charges:
            Number(item.damage_charges) || 0,

          // Form inputs for a NEW return (blank by default)
          returned_quantity: "",

          lost_quantity: "",

          damage_charges: "",

          price: Number(item.price) || 0,

          status:
            item.status || "active",

          end_date: item.end_date,
start_date: item.start_date,
initial_end_date: item.initial_end_date,
extend_date: ""
        }));

        setReturnData(initial);
      });
  };

  useEffect(() => {
    fetchData();
  }, [id]);

  // =========================================
  // ✅ FETCH PRODUCTS (same as Create Rental)
  // =========================================

  const fetchProducts = () => {

    fetch("/api/products")
      .then(res => res.json())
      .then(data =>
        setProducts(
          data.products || data
        )
      );
  };

  useEffect(() => {
    fetchProducts();
  }, []);

  if (!data) {
    return <div className="p-6">Loading...</div>;
  }

  const r = data.rental;

  const billHistory =
    data.billHistory || [];
    console.log(billHistory);

  const paymentHistory =
    data.paymentHistory || [];
    const recoveryRefunds =
  data.recoveryRefunds || [];

  // =========================================
  // ✅ CREDIT
  // =========================================

  const pendingAmount =
    Number(r.pending_amount || 0);

  const paidAmount =
    Number(r.paid_amount || 0);

  const isCreditCustomer =
    r.rental_type === "credit";

  // =========================================
  // ✅ SETTLEMENT LOCK
  // =========================================

  const isSettled =
    Number(r.settlement_done || 0) === 1;
    

  // =========================================
  // ✅ DATE FORMAT
  // =========================================

  const formatDate = (date) => {

    if (!date) return "-";

    return new Date(date)
      .toLocaleDateString("en-GB");
  };

  // =========================================
  // ✅ SETTLEMENT LOGIC
  // =========================================

  const settlementAmount =
    Number(r.settlement_amount || 0);

    console.log("settlementAmount", settlementAmount);
console.log("rental settlement_amount", r.settlement_amount);
const breakdown =
  r.settlement_breakdown || {};
  // =========================================
  // ✅ BILLING HISTORY TOTALS
  // =========================================

  const totalExtensions =
    billHistory
      .filter(
        row =>
          row.type?.toLowerCase() ===
          "extension"
      )
      .reduce(
        (sum, row) =>
          sum +
          Number(
            row.change_amount || 0
          ),
        0
      );

  const totalReductions =
    billHistory
      .filter(
        row =>
          row.type?.toLowerCase() ===
          "reduction"
      )
      .reduce(
        (sum, row) =>
          sum +
          Math.abs(
            Number(
              row.change_amount || 0
            )
          ),
        0
      );

  // Total labour / transport = creation-time column + ledger rows
  const sumByType = (type) =>
    billHistory
      .filter(
        row => row.type?.toLowerCase() === type
      )
      .reduce(
        (sum, row) => sum + num(row.change_amount),
        0
      );

  const totalLabour =
    num(r.labour_charges) + sumByType("labour");

  const totalTransport =
    num(r.transport_charges) + sumByType("transport");

    const totalAdditional =
  sumByType("additional");
const totalDiscount =
  Math.abs(sumByType("discount"));
  // =========================================
  // ✅ HANDLE CHANGE
  // =========================================

  const handleChange = (
    i,
    field,
    value
  ) => {

    const updated = [...returnData];

    updated[i][field] =
  value < 0 ? 0 : value;

    // Remaining = original - already returned - already lost
    const remaining =
      updated[i].quantity -
      num(updated[i].db_returned_quantity) -
      num(updated[i].db_lost_quantity);

    if (
      num(updated[i].returned_quantity) +
      num(updated[i].lost_quantity)
      >
      remaining
    ) {
      notify(
        "Returned + Lost cannot exceed remaining quantity",
        "error"
      );

      return;
    }

    setReturnData(updated);
  };

  // =========================================
  // ✅ RETURN ITEM
  // =========================================

  const handleReturnItem = async (
    item
  ) => {

    const res = await fetch(
      "/api/return-rental",
      {
        method: "POST",

        headers: {
          "Content-Type":
            "application/json"
        },

        body: JSON.stringify({

          rental_id: id,

          items: [
  {
    rental_item_id:
      item.rental_item_id,

    returned_quantity:
      num(item.returned_quantity),

    lost_quantity:
      num(item.lost_quantity),

    damage_charges:
      num(item.damage_charges)
  }
],

          actual_return_date:
            new Date()
              .toISOString()
              .split("T")[0],

          return_note: ""
        })
      }
    );

    const d = await res.json();

    notify(
      d.message,
      res.ok ? "success" : "error"
    );

    fetchData();
  };

  const handleRecover = async(item)=>{

const body=

recoverData[item.rental_item_id];

if(
!body?.qty ||
Number(body.qty)<=0
){

notify(
"Enter a valid recovery quantity",
"error"
);

return;

}
if(
Number(body.qty)>
Number(item.db_lost_quantity)
){

notify(
`Maximum recovery quantity is ${item.db_lost_quantity}`,
"error"
);

return;

}

const res=
await fetch(

"/api/recover-lost-product",

{

method:"POST",

headers:{
"Content-Type":"application/json"
},

body:JSON.stringify({

rental_item_id:
item.rental_item_id,

recovered_quantity:
Number(body.qty),

note:
body.note||""

})

}

);

const d=
await res.json();

notify(

d.message,

res.ok
? "success"
: "error"

);

if(res.ok){

setRecoverData(prev=>({

...prev,

[item.rental_item_id]:{}

}));

setShowRecover(prev=>({

...prev,

[item.rental_item_id]:false

}));

fetchData();

}

};

  // =========================================
  // ✅ MODIFY DATE
  // =========================================

  const handleExtend = async (
    item
  ) => {

    if (!item.extend_date) {
      notify("Select a date", "error");
      return;
    }

    const res = await fetch(
      "/api/extend-rental-item",
      {
        method: "POST",

        headers: {
          "Content-Type":
            "application/json"
        },

        body: JSON.stringify({
          rental_item_id:
            item.rental_item_id,

          new_end_date:
            item.extend_date
        })
      }
    );

    const d = await res.json();

    notify(
      d.message,
      res.ok ? "success" : "error"
    );

    fetchData();
  };

  // =========================================
  // ✅ FINAL SETTLEMENT
  // =========================================

 const handleSettlement = async () => {

  // REFUND CASE
  if (settlementAmount > 0) {
    console.log(
  "VALIDATION",
  returnedAmount,
  settlementAmount
);

  if (
    Number(returnedAmount) !==
    Number(settlementAmount)
  ) {

    notify(
      `Refund must be exactly ₹${settlementAmount}`,
      "error"
    );

    return;
  }
}

  // CUSTOMER PAYS CASE
  if (settlementAmount < 0) {

    if (
      Number(receivedAmount) !==
      Math.abs(Number(settlementAmount))
    ) {

      notify(
        `Amount must be exactly ₹${Math.abs(settlementAmount)}`,
        "error"
      );

      return;
    }
  }

  // existing fetch code below...

    const res = await fetch(
      "/api/settle-rental",
      {
        method: "POST",

        headers: {
          "Content-Type":
            "application/json"
        },

        body: JSON.stringify({

          rental_id: id,

          deposit_returned:
            settlementAmount > 0
              ? returnedAmount
              : 0,

          extra_received:
            settlementAmount < 0
              ? receivedAmount
              : 0,

          note: settlementNote
        })
      }
    );

    const d = await res.json();

    notify(
      d.message,
      res.ok ? "success" : "error"
    );

    fetchData();
  };

  // =========================================
  // ✅ COLLECT PAYMENT
  // =========================================

  const handleCollectPayment =
    async () => {

      if (!creditAmount) {
        notify("Enter an amount", "error");
        return;
      }

      const res = await fetch(
        "/api/collect-payment",
        {
          method: "POST",

          headers: {
            "Content-Type":
              "application/json"
          },

          body: JSON.stringify({

            rental_id: id,

            amount:
              Number(creditAmount),

            note: paymentNote
          })
        }
      );

      const d = await res.json();

      notify(
        d.message,
        res.ok ? "success" : "error"
      );

      setCreditAmount("");

      setPaymentNote("");

      fetchData();
    };

    // =========================================
// ✅ PAY RECOVERY REFUND
// =========================================

const handlePayRecoveryRefund = async (refund) => {

  const res = await fetch(
    "/api/pay-recovery-refund",
    {
      method: "POST",

      headers: {
        "Content-Type": "application/json"
      },

      body: JSON.stringify({

        refund_id: refund.id,

        amount: refund.amount,

        note: refund.note || ""

      })
    }
  );

  const d = await res.json();

  notify(
    d.message,
    res.ok ? "success" : "error"
  );

  if (res.ok) {
    fetchData();
  }

};
  // =========================================
  // ✅ NEW PRODUCT CHANGE (same as Create Rental)
  // =========================================

  const handleNewProductChange = (
    field,
    value
  ) => {

    const updated = { ...newProduct };

    // AUTO-FILL RENT
    if (field === "product_id") {

      const selected =
        products.find(p => p.id === value);

      updated.rent =
        selected
          ? Number(selected.rent_per_day) || 0
          : 0;
    }

    // STOCK CHECK
    if (field === "quantity") {

      const product =
        products.find(
          p => p.id === updated.product_id
        );

      if (
        product &&
        num(value) > product.available_quantity
      ) {
        notify(
          `Only ${product.available_quantity} items available`,
          "error"
        );
        return;
      }
    }

    updated[field] = value;

    setNewProduct(updated);
  };

  // =========================================
  // ✅ ADD PRODUCT TO RENTAL
  // =========================================

  const resetNewProduct = () =>
    setNewProduct({
      product_id: "",
      quantity: "",
      rent: 0,
      rent_date: "",
      return_date: "",
      transport_amount: "",
      transport_note: "",
      labour_amount: "",
      labour_note: ""
    });

  const handleAddProduct = async () => {

    if (!newProduct.product_id) {
      notify("Select a product", "error");
      return;
    }

    if (num(newProduct.quantity) <= 0) {
      notify("Enter a quantity", "error");
      return;
    }

    const res = await fetch(
      "/api/add-rental-item",
      {
        method: "POST",

        headers: {
          "Content-Type":
            "application/json"
        },

        body: JSON.stringify({
          rental_id: id,
          product_id:
            newProduct.product_id,
          quantity:
            num(newProduct.quantity),
          rent_date:
            newProduct.rent_date || null,
          return_date:
            newProduct.return_date || null,
          transport_amount:
            num(newProduct.transport_amount),
          transport_note:
            newProduct.transport_note || "",
          labour_amount:
            num(newProduct.labour_amount),
          labour_note:
            newProduct.labour_note || ""
        })
      }
    );

    const d = await res.json();

    notify(
      d.message,
      res.ok ? "success" : "error"
    );

    if (res.ok) {

      resetNewProduct();

      setShowAddProduct(false);

      fetchData();

      fetchProducts();
    }
  };

  // =========================================
  // ✅ ADD EXTRA CHARGE (transport/labour/additional)
  // =========================================

  const handleAddCharge = async () => {

    if (num(chargeForm.amount) <= 0) {
      notify("Enter a charge amount", "error");
      return;
    }

    const res = await fetch(
      "/api/add-rental-charge",
      {
        method: "POST",

        headers: {
          "Content-Type": "application/json"
        },

        body: JSON.stringify({
          rental_id: id,
          type: chargeForm.type,
          amount: num(chargeForm.amount),
          note: chargeForm.note || "",
          entry_date: chargeForm.entry_date || null
        })
      }
    );

    const d = await res.json();

    notify(
      d.message,
      res.ok ? "success" : "error"
    );

    if (res.ok) {

      setChargeForm({
        type: "transport",
        amount: "",
        note: "",
        entry_date: ""
      });

      fetchData();
    }
  };

    // =========================================
// ✅ SAFE NUMBER INPUT
// =========================================

const preventInvalidNumberInput = (e) => {

  // block: -, +, e, E
  if (
    e.key === "-" ||
    e.key === "+" ||
    e.key === "e" ||
    e.key === "E"
  ) {
    e.preventDefault();
  }

  // block arrow up/down
  if (
    e.key === "ArrowUp" ||
    e.key === "ArrowDown"
  ) {
    e.preventDefault();
  }
};

  return (

    <div className="min-h-screen bg-[#F5F7FB] p-4 md:p-6 space-y-6">

     <div className="bg-gradient-to-r from-indigo-600 via-violet-600 to-purple-600 rounded-[32px] p-5 md:p-8 text-white shadow-xl">

  <div className="flex flex-col lg:flex-row justify-between lg:items-center gap-6">

    <div>

      <p className="uppercase tracking-[4px] text-indigo-200 text-sm font-medium">
        Rental Management
      </p>

      <h1 className="text-2xl md:text-4xl font-bold mt-2">
        Rental Details
      </h1>

      <p className="text-indigo-100 mt-3">
        Manage returns, billing history,
        settlements and customer payments.
      </p>

    </div>

    <div className="flex gap-4 flex-wrap">

      <div className="bg-white/10 backdrop-blur-md border border-white/20 px-6 py-5 rounded-3xl min-w-[180px]">

        <p className="text-indigo-100 text-sm">
          Rental Type
        </p>

        <h2 className="text-2xl font-bold mt-1">
          {isCreditCustomer
            ? "Credit"
            : "Regular"}
        </h2>

      </div>

      <div className="bg-white/10 backdrop-blur-md border border-white/20 px-6 py-5 rounded-3xl min-w-[180px]">

        <p className="text-indigo-100 text-sm">
          Products
        </p>

        <h2 className="text-2xl font-bold mt-1">
          {returnData.length}
        </h2>

      </div>

    </div>

  </div>

</div>

      {/* ✅ SETTLEMENT COMPLETED */}

      {!isCreditCustomer && isSettled && (
        <div className="bg-green-100 border border-green-300 text-green-700 px-4 py-3 rounded">
          Settlement Completed
        </div>
      )}

      {isCreditCustomer &&
        paidAmount > 0 &&
        Number(r.pending_amount || 0) === 0 && (
        <div className="bg-green-100 border border-green-300 text-green-700 px-4 py-3 rounded">
          Settlement Completed
        </div>
      )}

      <div className="grid grid-cols-1 lg:grid-cols-12 gap-6">

        {/* ========================================= */}
        {/* LEFT SIDE */}
        {/* ========================================= */}

        <div className="col-span-1 lg:col-span-7 space-y-6">

          {/* CUSTOMER */}

         <div className="bg-white rounded-[24px] border border-gray-100 shadow-sm p-6">

  <div className="flex flex-col md:flex-row justify-between md:items-start gap-4">

    <div className="flex-1">

      <p className="text-sm font-medium text-indigo-600 uppercase tracking-wide">
        Customer Details
      </p>

      <h2 className="text-2xl font-semibold text-gray-800 mt-2">
        {r.first_name}
        {" "}
        {r.last_name}
      </h2>

      <div className="space-y-2 mt-4 text-sm text-gray-600">

        <p className="flex items-center gap-2">

          <span className="font-medium text-gray-800">
            Phone:
          </span>

          {r.phone}

        </p>

        <p className="flex items-start gap-2">

          <span className="font-medium text-gray-800">
            Address:
          </span>

          <span>
            {r.address}
          </span>

        </p>

      </div>

    </div>

    <div className={`px-4 py-2 rounded-xl text-sm font-medium whitespace-nowrap

      ${
        isCreditCustomer
          ? "bg-red-100 text-red-700"
          : "bg-indigo-100 text-indigo-700"
      }`}>

      {isCreditCustomer
        ? "Credit Customer"
        : "Regular Rental"}

    </div>

  </div>

</div>

          {/* PRODUCTS */}

          <div className="bg-white rounded-[24px] border border-gray-100 shadow-sm p-6 space-y-4">

               <div className="flex flex-col lg:flex-row justify-between lg:items-center gap-6">

          <div>

               <h2 className="text-xl font-semibold text-gray-800">
        Rental Products
          </h2>

             <p className="text-sm text-gray-500 mt-1">
        Manage returns & rental modifications
           </p>

       </div>

    <div className="flex items-center gap-3">

      <div className="bg-indigo-100 text-indigo-700 px-3 py-1 rounded-xl text-sm font-medium">

        {returnData.length} Items

      </div>

      <button
      disabled={isSettled}

        onClick={() =>
          setShowAddProduct(prev => !prev)
        }

        className="bg-gradient-to-r from-indigo-600 to-purple-600 text-white px-4 py-2 rounded-xl text-sm font-medium hover:shadow-lg transition disabled:opacity-50"
      >

        + Add Product

      </button>

    </div>

  </div>

  {/* ADD PRODUCT FORM (reuses Create Rental fields) */}

  {showAddProduct && !isSettled && (() => {

    

    let addDays = 0;

if (
  newProduct.rent_date &&
  newProduct.return_date
) {

  const start =
    new Date(newProduct.rent_date);

  const end =
    new Date(newProduct.return_date);

  addDays = Math.max(
    1,
    Math.ceil(
      (end - start) /
      (1000 * 60 * 60 * 24)
    ) + 1
  );

}

   const addTotal =
  addDays > 0
    ? (
        (Number(newProduct.rent) || 0) *
        (Number(newProduct.quantity) || 0) *
        addDays
      )
    : 0;
    return (

      <div className="border border-indigo-200 rounded-3xl p-6 bg-indigo-50/40">

        <div className="grid grid-cols-1 md:grid-cols-12 gap-4 items-center">

          <div className="md:col-span-6">

            <label className="text-sm text-gray-500 block mb-2">
              Product
            </label>

            <select
              value={newProduct.product_id}

              onChange={(e) =>
                handleNewProductChange(
                  "product_id",
                  Number(e.target.value)
                )
              }

              className="w-full border border-gray-200 bg-white rounded-2xl px-5 py-4 outline-none focus:ring-2 focus:ring-indigo-500"
            >

              <option value="">
                Select Product
              </option>

              {products.map(p => (

                <option
                  key={p.id}
                  value={p.id}
                >

                  {p.name}
                  {" "}
                  (Available:
                  {" "}
                  {p.available_quantity})

                </option>

              ))}

            </select>

          </div>

          <div className="md:col-span-2">

            <label className="text-sm text-gray-500 block mb-2">
              Qty
            </label>

            <input
              type="number"
              min="0"

              onKeyDown={preventInvalidNumberInput}

              onWheel={(e) => e.target.blur()}

              value={newProduct.quantity}

              placeholder="0"

              onChange={(e) =>
                handleNewProductChange(
                  "quantity",
                  e.target.value
                )
              }

              className="w-full border border-gray-200 bg-white rounded-2xl px-4 py-4 outline-none focus:ring-2 focus:ring-indigo-500"
            />

          </div>

          <div className="md:col-span-2">

            <label className="text-sm text-gray-500 block mb-2">
              Rent/Day
            </label>

            <div className="bg-indigo-50 text-indigo-700 font-semibold rounded-2xl px-4 py-4 text-center">
              ₹{newProduct.rent}
            </div>

          </div>

          <div className="md:col-span-2">

            <label className="text-sm text-gray-500 block mb-2">
              Total
            </label>

            <div className="bg-green-50 text-green-700 font-bold rounded-2xl px-4 py-4 text-center">
              ₹{addTotal}
            </div>

          </div>

        </div>

        {/* ADD DATE + OPTIONAL CHARGES */}

        <div className="grid grid-cols-1 md:grid-cols-12 gap-4 mt-4">

          <div className="md:col-span-3">

            <label className="text-sm text-gray-500 block mb-2">
              Rent Date
            </label>

            <input
              type="date"

              value={newProduct.rent_date}

              onChange={(e) =>
                handleNewProductChange(
                  "rent_date",
                  e.target.value
                )
              }

              className="w-full border border-gray-200 bg-white rounded-2xl px-4 py-3 outline-none focus:ring-2 focus:ring-indigo-500"
            />

          </div>

          <div className="md:col-span-3">

            <label className="text-sm text-gray-500 block mb-2">
              Return Date
            </label>

            <input
              type="date"

              value={newProduct.return_date}

              onChange={(e) =>
                handleNewProductChange(
                  "return_date",
                  e.target.value
                )
              }

              className="w-full border border-gray-200 bg-white rounded-2xl px-4 py-3 outline-none focus:ring-2 focus:ring-indigo-500"
            />

          </div>

          <div className="md:col-span-3">

            <label className="text-sm text-gray-500 block mb-2">
              Transport Charge
            </label>

            <input
              type="number"
              min="0"

              placeholder="0"

              onKeyDown={preventInvalidNumberInput}

              onWheel={(e) => e.target.blur()}

              value={newProduct.transport_amount}

              onChange={(e) =>
                handleNewProductChange(
                  "transport_amount",
                  e.target.value
                )
              }

              className="w-full border border-gray-200 bg-white rounded-2xl px-4 py-3 outline-none focus:ring-2 focus:ring-indigo-500"
            />

          </div>

          <div className="md:col-span-3">

            <label className="text-sm text-gray-500 block mb-2">
              Labour Charge
            </label>

            <input
              type="number"
              min="0"

              placeholder="0"

              onKeyDown={preventInvalidNumberInput}

              onWheel={(e) => e.target.blur()}

              value={newProduct.labour_amount}

              onChange={(e) =>
                handleNewProductChange(
                  "labour_amount",
                  e.target.value
                )
              }

              className="w-full border border-gray-200 bg-white rounded-2xl px-4 py-3 outline-none focus:ring-2 focus:ring-indigo-500"
            />

          </div>

          <div className="md:col-span-6">

            <label className="text-sm text-gray-500 block mb-2">
              Transport Note
            </label>

            <input
              type="text"

              placeholder="Reason / details (optional)"

              value={newProduct.transport_note}

              onChange={(e) =>
                handleNewProductChange(
                  "transport_note",
                  e.target.value
                )
              }

              className="w-full border border-gray-200 bg-white rounded-2xl px-4 py-3 outline-none focus:ring-2 focus:ring-indigo-500"
            />

          </div>

          <div className="md:col-span-6">

            <label className="text-sm text-gray-500 block mb-2">
              Labour Note
            </label>

            <input
              type="text"

              placeholder="Reason / details (optional)"

              value={newProduct.labour_note}

              onChange={(e) =>
                handleNewProductChange(
                  "labour_note",
                  e.target.value
                )
              }

              className="w-full border border-gray-200 bg-white rounded-2xl px-4 py-3 outline-none focus:ring-2 focus:ring-indigo-500"
            />

          </div>

        </div>

        <div className="flex flex-col sm:flex-row gap-3 mt-4">

          <button
            onClick={handleAddProduct}

            className="px-5 py-3 rounded-xl bg-indigo-600 text-white text-sm font-medium hover:bg-indigo-700"
          >
            Save Product
          </button>

          <button
            onClick={() => {
              setShowAddProduct(false);
              resetNewProduct();
            }}

            className="px-5 py-3 rounded-xl bg-gray-200 text-gray-700 text-sm font-medium hover:bg-gray-300"
          >
            Cancel
          </button>

        </div>

      </div>

    );
  })()}

  {returnData.map((item, i) => {

   const start =
  new Date(
    item.start_date ||
    r.rent_date
  );

    const end =
      new Date(
        item.end_date ||
        r.return_date
      );

    let days =
      Math.ceil(
        (end - start) /
        (1000 * 60 * 60 * 24)
      ) + 1;

    if (
      isNaN(days) ||
      days <= 0
    ) {
      days = 1;
    }

   // Remaining (current) qty after any partial returns
const remaining =
  item.quantity -
  num(item.db_returned_quantity) -
  num(item.db_lost_quantity);

const latestHistory =
  [...billHistory]
    .filter(row => {
      const desc =
        (row.description || "")
          .toLowerCase();

      return (
        Number(row.rental_item_id) ===
          Number(item.rental_item_id) &&
        !desc.includes("labour") &&
        !desc.includes("transport")
      );
    })
    .sort((a, b) => b.id - a.id)[0];

console.log(
  "ITEM:",
  item.name,
  "LATEST HISTORY:",
  latestHistory
);

const total =
  latestHistory
    ? Number(latestHistory.new_amount || 0)
    : (
        item.quantity *
        item.price *
        days
      );
   const isItemReturned =
    remaining === 0;

    return (

      <div
         key={item.rental_item_id}
        className="border border-gray-100 rounded-2xl p-5 bg-[#FAFBFD] space-y-4 hover:border-indigo-200 transition-all"
      >

        {/* TOP */}

        <div className="flex flex-col md:flex-row justify-between md:items-start gap-4">

          <div className="flex-1">

            <div className="flex items-center gap-2 flex-wrap">

              <h3 className="font-semibold text-lg text-gray-800">
                {item.name}
              </h3>

              <span className={`text-xs px-2 py-1 rounded-full font-medium

                ${
                  isItemReturned
                    ? "bg-green-100 text-green-700"
                    : "bg-gray-100 text-gray-600"
                }`}>

                {isItemReturned
                  ? "Returned"
                  : item.status}

              </span>

            </div>

            <div className="grid grid-cols-1 sm:grid-cols-2 gap-x-6 gap-y-2 mt-3 text-sm text-gray-600">

              <p>
                Original Qty:
                {" "}
                <span className="font-medium">
                  {item.quantity}
                </span>
              </p>

              <p>
                Returned Qty:
                {" "}
                <span className="font-medium text-green-600">
                  {item.db_returned_quantity}
                </span>
              </p>

              <p>
                Lost Qty:
                {" "}
                <span className="font-medium text-red-600">
                  {item.db_lost_quantity}
                </span>
              </p>

              <p>
                Current Qty:
                {" "}
                <span className="font-medium text-indigo-600">
                  {remaining}
                </span>
              </p>

              <p>
                Per Day:
                {" "}
                <span className="font-medium">
                  ₹{item.price}
                </span>
              </p>

              <p>
                Days:
                {" "}
                <span className="font-medium">
                  {days}
                </span>
              </p>

            </div>

            {/* DAMAGE CHARGES ON THIS PRODUCT */}

            {num(item.db_damage_charges) > 0 && (
              <div className="mt-3 inline-flex items-center gap-2 bg-red-50 border border-red-100 text-red-700 px-3 py-1.5 rounded-xl text-sm font-medium">
                Damage Charges: ₹{item.db_damage_charges}
              </div>
            )}

            <div className="flex flex-wrap gap-4 mt-3 text-xs text-gray-500">

              <p>
                Rent:
{formatDate(item.start_date || r.rent_date)}
              </p>

              <p>
                Initial:
{formatDate(item.initial_end_date)}
              </p>

              <p>
                Current:
{formatDate(item.end_date)}
              </p>

            </div>

          </div>

          <div className="text-right">

            <h2 className="text-2xl font-bold text-indigo-600">
              ₹{total}
            </h2>

            <p className="text-xs text-gray-400 mt-1">
              Rental Total
            </p>

          </div>

        </div>

        {/* BUTTONS */}

        <div className="flex gap-3 flex-wrap">

          <button
            disabled={
              isSettled ||
              isItemReturned
            }

            onClick={() =>
              setShowExtend(
                prev => ({
                  ...prev,
                  [i]:
                    !prev[i]
                })
              )
            }

            className="px-4 py-2 rounded-xl bg-indigo-600 text-white text-sm font-medium hover:bg-indigo-700 disabled:opacity-50"
          >

            Modify Date

          </button>

          <button
           disabled={remaining === 0}

            onClick={() =>
              setShowReturn(
                prev => ({
                  ...prev,
                  [i]:
                    !prev[i]
                })
              )
            }

            className="px-4 py-2 rounded-xl bg-green-600 text-white text-sm font-medium hover:bg-green-700 disabled:opacity-50"
          >

            Return

          </button>
          {num(item.db_lost_quantity) > 0 && (

<button

disabled={Number(item.db_lost_quantity) === 0}

onClick={()=>
setShowRecover(prev=>({

...prev,

[i]:!prev[i]

}))
}

className="px-4 py-2 rounded-xl bg-orange-500 text-white text-sm font-medium hover:bg-orange-600 disabled:opacity-50"
>

Recover Lost

</button>

)}

        </div>

        {/* MODIFY DATE */}

        {showExtend[i] && (

          <div className="flex flex-col sm:flex-row gap-3 pt-2">

            <input
              type="date"

              disabled={
                isSettled ||
                isItemReturned
              }

              value={
                item.extend_date || ""
              }

              onChange={(e) => {

                const updated =
                  [...returnData];

                updated[i]
                  .extend_date =
                  e.target.value;

                setReturnData(
                  updated
                );
              }}

              className="flex-1 border border-gray-200 bg-white rounded-xl px-4 py-3 outline-none focus:ring-2 focus:ring-indigo-500"
            />

            <button
              disabled={
                isSettled ||
                isItemReturned
              }

              onClick={() =>
                handleExtend(item)
              }

              className="px-5 py-3 rounded-xl bg-indigo-600 text-white text-sm font-medium hover:bg-indigo-700 disabled:opacity-50"
            >

              Save

            </button>

          </div>

        )}

        {/* RETURN */}

        {showReturn[i] && (

          <div className="grid grid-cols-1 md:grid-cols-3 gap-3 pt-2">

            <div>

              <label className="text-xs text-gray-500 block mb-1">
                Return Qty
              </label>

              <input
                type="number"
                min="0"

                placeholder="0"

                value={item.returned_quantity}

                onKeyDown={preventInvalidNumberInput}

                onWheel={(e) => e.target.blur()}

                onChange={(e) => {

                  const value = Math.max(
                    0,
                    num(e.target.value)
                  );

                  handleChange(
                    i,
                    "returned_quantity",
                    value
                  );
                }}

                className="w-full border border-gray-200 bg-white rounded-xl px-4 py-3 outline-none focus:ring-2 focus:ring-indigo-500"
              />

            </div>

            <div>

              <label className="text-xs text-gray-500 block mb-1">
                Lost Qty
              </label>

              <input
                type="number"
                min="0"

                disabled={
                  isSettled ||
                  isItemReturned
                }

                placeholder="0"

                value={item.lost_quantity}

                onKeyDown={preventInvalidNumberInput}

                onWheel={(e) => e.target.blur()}

                onChange={(e) => {

                  const value = Math.max(
                    0,
                    num(e.target.value)
                  );

                  handleChange(
                    i,
                    "lost_quantity",
                    value
                  );
                }}

                className="w-full border border-gray-200 bg-white rounded-xl px-4 py-3 outline-none focus:ring-2 focus:ring-indigo-500"
              />

            </div>

            <div>

              <label className="text-xs text-gray-500 block mb-1">
                      Additional Damage Charges
             </label>

              <input
                type="number"
                min="0"

                disabled={
                  isSettled ||
                  isItemReturned
                }

                placeholder="0"

                value={item.damage_charges}

                onKeyDown={preventInvalidNumberInput}

                onWheel={(e) => e.target.blur()}

                onChange={(e) => {

                  const value = Math.max(
                    0,
                    num(e.target.value)
                  );

                  handleChange(
                    i,
                    "damage_charges",
                    value
                  );
                }}

                className="w-full border border-gray-200 bg-white rounded-xl px-4 py-3 outline-none focus:ring-2 focus:ring-indigo-500"
              />

            </div>

            <button
             disabled={remaining === 0}

              onClick={() =>
                handleReturnItem(item)
              }

              className="md:col-span-3 px-5 py-3 rounded-xl bg-green-600 text-white text-sm font-medium hover:bg-green-700 disabled:opacity-50"
            >

              Submit Return

            </button>

          </div>

        )}
        {showRecover[i] && (

<div className="grid grid-cols-1 md:grid-cols-3 gap-3 pt-2">

<div>

<label className="text-xs text-gray-500 block mb-1">

Recover Qty

</label>

<input
type="number"
min="1"
max={item.db_lost_quantity}

disabled={Number(item.db_lost_quantity) === 0}

onKeyDown={preventInvalidNumberInput}

onWheel={(e)=>e.target.blur()}

value={
recoverData[item.rental_item_id]?.qty || ""
}

onChange={(e)=>

setRecoverData(prev=>({

...prev,

[item.rental_item_id]:{

...prev[item.rental_item_id],

qty:e.target.value

}

}))

}

className="w-full border border-gray-200 bg-white rounded-xl px-4 py-3"
/>

</div>

<div className="md:col-span-2">

<label className="text-xs text-gray-500 block mb-1">

Note

</label>

<input
type="text"

disabled={Number(item.db_lost_quantity) === 0}

value={
recoverData[item.rental_item_id]?.note || ""
}

onChange={(e)=>

setRecoverData(prev=>({

...prev,

[item.rental_item_id]:{

...prev[item.rental_item_id],

note:e.target.value

}

}))

}

className="w-full border border-gray-200 bg-white rounded-xl px-4 py-3"
/>

</div>

<button

className="md:col-span-3 px-5 py-3 rounded-xl bg-orange-500 text-white"

onClick={()=>
handleRecover(item)
}

>

Recover Product

</button>

</div>

)}

      </div>

    );
  })}

</div>

        </div>

        {/* ========================================= */}
        {/* RIGHT SIDE */}
        {/* ========================================= */}

        <div className="col-span-1 lg:col-span-5 space-y-6">

          {/* INVOICE BUTTON */}

          <Link
            to={`/invoice/${id}`}
            className="block w-full text-center bg-gradient-to-r from-gray-800 to-gray-900 text-white py-3 rounded-2xl font-semibold hover:shadow-lg transition"
          >
            View Full Invoice
          </Link>

          {/* BILLING TABS */}

          <div className="bg-white rounded-2xl border border-gray-100 shadow-sm p-2 overflow-x-auto">

            {[
              { key: "initial", label: "Initial Billing" },
              { key: "modifications", label: "Modifications" },
              { key: "history", label: "Billing History" },
              { key: "additional", label: "Additional Charges" },
              { key: "settlement", label: "Settlement Summary" }
            ].map(t => (
              <button
                key={t.key}
                onClick={() => setActiveTab(t.key)}
                className={`px-4 py-2 rounded-xl text-sm font-medium transition
                  ${
                    activeTab === t.key
                      ? "bg-indigo-600 text-white"
                      : "text-gray-600 hover:bg-gray-100"
                  }`}
              >
                {t.label}
              </button>
            ))}

          </div>

          {/* INITIAL BILLING */}

          {activeTab === "initial" && (
<div className="bg-white rounded-[32px] border border-gray-100 shadow-sm p-8">

  <div className="flex justify-between items-center mb-6">

    <div>

      <h2 className="text-2xl font-bold text-gray-800">
        Initial Billing
      </h2>

      <p className="text-sm text-gray-500 mt-1">
        Original rental invoice details
      </p>

    </div>

    <div className="bg-indigo-100 text-indigo-700 px-4 py-2 rounded-2xl text-sm font-semibold">

      Invoice

    </div>

  </div>

  <div className="space-y-4">

    {/* PRODUCT RENT */}

    <div className="flex justify-between items-center bg-[#F8FAFC] border border-gray-100 rounded-2xl px-5 py-4">

      <div>

        <p className="font-semibold text-gray-800">
          Product Rent
        </p>

        <p className="text-xs text-gray-500 mt-1">
          Initial rental amount
        </p>

      </div>

     <h3 className="text-2xl font-bold text-indigo-600">
  ₹{r.original_rental_amount || r.total_amount || 0}
</h3>
    </div>

    {/* LABOUR */}

    <div className="flex justify-between items-center bg-[#F8FAFC] border border-gray-100 rounded-2xl px-5 py-4">

      <div>

        <p className="font-semibold text-gray-800">
          Labour Charges
        </p>

      </div>

      <h3 className="text-xl font-bold text-gray-700">
        ₹{r.labour_charges || 0}
      </h3>

    </div>

    {/* TRANSPORT */}

    <div className="flex justify-between items-center bg-[#F8FAFC] border border-gray-100 rounded-2xl px-5 py-4">

      <div>

        <p className="font-semibold text-gray-800">
          Transport Charges
        </p>

      </div>

      <h3 className="text-xl font-bold text-gray-700">
        ₹{r.transport_charges || 0}
      </h3>

    </div>

    {/* DEPOSIT */}

    {!isCreditCustomer && (

      <div className="flex justify-between items-center bg-amber-50 border border-amber-100 rounded-2xl px-5 py-4">

        <div>

          <p className="font-semibold text-amber-700">
            Security Deposit
          </p>

          <p className="text-xs text-amber-500 mt-1">
            Refundable security amount
          </p>

        </div>

        <h3 className="text-2xl font-bold text-amber-700">
          ₹{r.deposit || 0}
        </h3>

      </div>

    )}

  </div>

  {/* FINAL COLLECTION */}

  <div className="bg-gradient-to-r from-indigo-50 via-violet-50 to-purple-50 border border-indigo-100 rounded-3xl p-6 mt-6">

    <p className="text-sm uppercase tracking-wide text-indigo-500 font-semibold">

      {isCreditCustomer
        ? "Initial Collection"
        : "Grand Collected"}

    </p>

    <h2 className="text-5xl font-bold text-indigo-700 mt-3">
      ₹{r.total_collected || 0}
    </h2>

    {isCreditCustomer && (

      <div className="grid grid-cols-2 gap-4 mt-6">

        <div className="bg-white border border-green-100 rounded-2xl p-4 shadow-sm">

          <p className="text-sm text-gray-500">
            Paid Amount
          </p>

          <h3 className="text-2xl font-bold text-green-600 mt-1">
            ₹{paidAmount}
          </h3>

        </div>

        <div className="bg-white border border-red-100 rounded-2xl p-4 shadow-sm">

          <p className="text-sm text-gray-500">
            Pending Amount
          </p>

          <h3 className="text-2xl font-bold text-red-600 mt-1">
            ₹{pendingAmount}
          </h3>

        </div>

      </div>

    )}

  </div>

</div>
)}

          {/* RENTAL MODIFICATIONS */}

          {activeTab === "modifications" && (
<div className="bg-white rounded-[32px] border border-gray-100 shadow-sm p-8">

  <div className="flex justify-between items-center mb-6">

    <div>

      <h2 className="text-2xl font-bold text-gray-800">
        Rental Modifications
      </h2>

      <p className="text-sm text-gray-500 mt-1">
        Extensions & reductions tracking
      </p>

    </div>

    <div className="bg-violet-100 text-violet-700 px-4 py-2 rounded-2xl text-sm font-semibold">

      Billing Changes

    </div>

  </div>

  <div className="space-y-4">

    {/* EXTENSIONS */}

    <div className="flex justify-between items-center bg-green-50 border border-green-100 rounded-2xl px-5 py-5">

      <div>

        <p className="font-semibold text-green-700">
          Extensions
        </p>

        <p className="text-xs text-green-500 mt-1">
          Extra rental charges added
        </p>

      </div>

      <div className="text-right">

        <h3 className="text-3xl font-bold text-green-700">
          +₹{totalExtensions}
        </h3>

      </div>

    </div>

    {/* REDUCTIONS */}

    <div className="flex justify-between items-center bg-orange-50 border border-orange-100 rounded-2xl px-5 py-5">

      <div>

        <p className="font-semibold text-orange-700">
          Reductions
        </p>

        <p className="text-xs text-orange-500 mt-1">
          Reduced rental amount
        </p>

      </div>

      <div className="text-right">

        <h3 className="text-3xl font-bold text-orange-700">
          -₹{totalReductions}
        </h3>

      </div>

    </div>

  </div>

</div>
)}

          {/* BILLING HISTORY */}

         {activeTab === "history" && (
<div className="bg-white rounded-[32px] border border-gray-100 shadow-sm p-8">

  <div className="flex justify-between items-center mb-6">

    <div>

      <h2 className="text-2xl font-bold text-gray-800">
        Billing History
      </h2>

      <p className="text-sm text-gray-500 mt-1">
        Complete rental billing timeline
      </p>

    </div>

    <div className="bg-indigo-100 text-indigo-700 px-4 py-2 rounded-2xl text-sm font-semibold">

      Timeline

    </div>

  </div>

  <div className="space-y-4 max-h-[500px] overflow-auto pr-2">

    {billHistory.map((row, i) => (

      <div
        key={i}
        className="relative bg-[#F8FAFC] border border-gray-100 rounded-3xl p-5 hover:shadow-sm transition-all"
      >

        {/* TYPE BADGE */}

        <div className={`absolute top-5 right-5 px-3 py-1 rounded-full text-xs font-semibold

          ${
            Number(row.change_amount) >= 0
              ? "bg-green-100 text-green-700"
              : "bg-orange-100 text-orange-700"
          }`}>

          {row.type}

        </div>

        <div className="space-y-3">

          {/* TOP */}

          <div className="flex justify-between items-start pr-24 gap-4">

            <div>

              <h3 className="font-bold text-gray-800 text-lg">
                {row.name || row.description}
              </h3>

              <p className="text-sm text-gray-500 mt-1">
                {row.description}
              </p>

              {row.note && (
                <p className="text-xs text-gray-400 mt-1 italic">
                  Note: {row.note}
                </p>
              )}

            </div>

            <div
              className={
                Number(row.change_amount) >= 0
                  ? "text-green-600 font-bold text-xl"
                  : "text-orange-600 font-bold text-xl"
              }
            >

              {Number(row.change_amount) >= 0
                ? "+"
                : "-"
              }

              ₹
              {Math.abs(
                Number(row.change_amount)
              )}

            </div>

          </div>

          {/* COMPARISON */}

          <div className="bg-white border border-gray-100 rounded-2xl px-4 py-3 flex justify-between items-center text-sm">

            <div>

              <p className="text-gray-500">
                Previous Amount
              </p>

              <h4 className="font-bold text-gray-700 mt-1">
                ₹{row.old_amount}
              </h4>

            </div>

            <div className="text-gray-300 text-xl font-bold">
              →
            </div>

            <div className="text-right">

              <p className="text-gray-500">
                New Amount
              </p>

              <h4 className="font-bold text-indigo-600 mt-1">
                ₹{row.new_amount}
              </h4>

            </div>

          </div>

          {/* DATE */}

          <div className="flex justify-between items-center pt-1">

            <p className="text-xs text-gray-400">
              {formatDate(row.entry_date || row.created_at)}
            </p>

          </div>

        </div>

      </div>

    ))}

  </div>

</div>
)}

{activeTab === "additional" && (
<>
<div className="bg-white rounded-[32px] border border-gray-100 shadow-sm p-8">

  <div className="flex justify-between items-center mb-6">

    <div>

      <h2 className="text-2xl font-bold text-gray-800">
        Additional Charges
      </h2>

      <p className="text-sm text-gray-500 mt-1">
        Lost & damage deductions
      </p>

    </div>

    <div className="bg-red-100 text-red-700 px-4 py-2 rounded-2xl text-sm font-semibold">

      Deductions

    </div>

  </div>

  <div className="space-y-4">

    {/* LOST */}

    <div className="flex justify-between items-center bg-red-50 border border-red-100 rounded-2xl px-5 py-5">

      <div>

        <p className="font-semibold text-red-700">
          Lost Charges
        </p>

        <p className="text-xs text-red-500 mt-1">
          Missing product penalties
        </p>

      </div>

      <h3 className="text-3xl font-bold text-red-700">
        ₹{r.lost_charges || 0}
      </h3>

    </div>

    {/* DAMAGE */}

    <div className="flex justify-between items-center bg-red-50 border border-red-100 rounded-2xl px-5 py-5">

      <div>

        <p className="font-semibold text-red-700">
          Damage Charges
        </p>

        <p className="text-xs text-red-500 mt-1">
          Repair & maintenance deductions
        </p>

      </div>

      <h3 className="text-3xl font-bold text-red-700">
        ₹{r.damage_charges || 0}
      </h3>

    </div>

    {/* TOTAL */}

    <div className="flex justify-between items-center bg-gradient-to-r from-red-500 to-rose-500 rounded-3xl px-6 py-6 text-white shadow-lg">

      <div>

        <p className="text-sm uppercase tracking-wide font-medium text-red-100">
          Total Extra Charges
        </p>

        <p className="text-xs text-red-100 mt-1">
          Final deductions applied
        </p>

      </div>

      <h2 className="text-4xl font-bold">
        ₹{r.total_extra_charges || 0}
      </h2>

    </div>

  </div>

</div>

{/* LABOUR / TRANSPORT TOTALS */}

<div className="bg-white rounded-[32px] border border-gray-100 shadow-sm p-8">

  <h2 className="text-2xl font-bold text-gray-800 mb-4">
    Labour & Transport
  </h2>

<div className="grid grid-cols-3 gap-4">
  
    <div className="bg-slate-50 border border-slate-100 rounded-2xl px-5 py-4">
      <p className="text-sm text-gray-500">
        Total Labour Charges
      </p>
      <h3 className="text-2xl font-bold text-slate-700 mt-1">
        ₹{totalLabour}
      </h3>
    </div>

    <div className="bg-slate-50 border border-slate-100 rounded-2xl px-5 py-4">
      <p className="text-sm text-gray-500">
        Total Transport Charges
      </p>
      <h3 className="text-2xl font-bold text-slate-700 mt-1">
        ₹{totalTransport}
      </h3>
    </div>
    <div className="bg-slate-50 border border-slate-100 rounded-2xl px-5 py-4">
  <p className="text-sm text-gray-500">
    Total Additional Charges
  </p>

  <h3 className="text-2xl font-bold text-slate-700 mt-1">
    ₹{totalAdditional}
  </h3>
</div>

  </div>

</div>

{/* ADD EXTRA CHARGE (transport / labour / additional) */}

<div className="bg-white rounded-[32px] border border-gray-100 shadow-sm p-8 space-y-4">

  <div>
    <h2 className="text-2xl font-bold text-gray-800">
      Add Charge
    </h2>
    <p className="text-sm text-gray-500 mt-1">
      Transport, labour or other charges with a note
    </p>
  </div>

  <div className="grid grid-cols-2 gap-4">

    <div className="md:col-span-2">
      <label className="text-sm text-gray-500 block mb-2">
        Charge Type
      </label>
      <select
        value={chargeForm.type}
        disabled={isSettled}
        onChange={(e) =>
          setChargeForm({
            ...chargeForm,
            type: e.target.value
          })
        }
        className="w-full border border-gray-200 bg-white rounded-2xl px-5 py-4 outline-none focus:ring-2 focus:ring-indigo-500"
      >
        <option value="transport">Transport</option>
        <option value="labour">Labour</option>
        <option value="additional">Additional</option>
        <option value="discount">Discount</option>
      </select>
    </div>

    <div>
      <label className="text-sm text-gray-500 block mb-2">
        Amount
      </label>
      <input
        type="number"
        min="0"
        placeholder="0"
        disabled={isSettled}
        onKeyDown={preventInvalidNumberInput}
        onWheel={(e) => e.target.blur()}
        value={chargeForm.amount}
        onChange={(e) =>
          setChargeForm({
            ...chargeForm,
            amount: e.target.value
          })
        }
        className="w-full border border-gray-200 bg-gray-50 rounded-2xl px-5 py-4 outline-none focus:ring-2 focus:ring-indigo-500"
      />
    </div>

    <div>
      <label className="text-sm text-gray-500 block mb-2">
        Date
      </label>
      <input
        type="date"
        disabled={isSettled}
        value={chargeForm.entry_date}
        onChange={(e) =>
          setChargeForm({
            ...chargeForm,
            entry_date: e.target.value
          })
        }
        className="w-full border border-gray-200 bg-gray-50 rounded-2xl px-5 py-4 outline-none focus:ring-2 focus:ring-indigo-500"
      />
    </div>

    <div className="md:col-span-2">
      <label className="text-sm text-gray-500 block mb-2">
        Note
      </label>
      <input
        type="text"
        placeholder="Reason / details (optional)"
        disabled={isSettled}
        value={chargeForm.note}
        onChange={(e) =>
          setChargeForm({
            ...chargeForm,
            note: e.target.value
          })
        }
        className="w-full border border-gray-200 bg-gray-50 rounded-2xl px-5 py-4 outline-none focus:ring-2 focus:ring-indigo-500"
      />
    </div>

  </div>

  <button
    disabled={isSettled}
    onClick={handleAddCharge}
    className="w-full bg-gradient-to-r from-indigo-600 to-purple-600 text-white py-4 rounded-2xl font-semibold hover:shadow-lg transition disabled:opacity-50"
  >
    Add Charge
  </button>

</div>
</>
)}

          {/* SETTLEMENT */}

          {activeTab === "settlement" && !isCreditCustomer && (

         <div className="bg-white rounded-[32px] border border-gray-100 shadow-sm p-8 space-y-6">

         <div>

      <h2 className="text-2xl font-bold text-gray-800">
        Settlement Summary
      </h2>

      <p className="text-sm text-gray-500 mt-1">
        Complete refund & deduction breakdown
      </p>

    </div>

    {/* BREAKDOWN */}

    <div className="space-y-4">

      {/* DEPOSIT */}

      <div className="flex justify-between items-center bg-indigo-50 border border-indigo-100 rounded-2xl px-5 py-4">

        <div>

          <p className="font-semibold text-indigo-700">
            Security Deposit
          </p>

          <p className="text-xs text-indigo-500 mt-1">
            Refundable amount collected initially
          </p>

        </div>

        <h3 className="text-xl font-bold text-indigo-700">
          ₹{r.deposit || 0}
        </h3>

      </div>

      {/* REDUCTIONS */}

      {totalReductions > 0 && (

        <div className="flex justify-between items-center bg-green-50 border border-green-100 rounded-2xl px-5 py-4">

          <div>

            <p className="font-semibold text-green-700">
              Rental Reductions
            </p>

            <p className="text-xs text-green-500 mt-1">
              Refund for reduced rental days
            </p>

          </div>

          <h3 className="text-xl font-bold text-green-700">
            +₹{totalReductions}
          </h3>

        </div>

      )}
      

      {/* EXTENSIONS */}

      {totalExtensions > 0 && (

        <div className="flex justify-between items-center bg-orange-50 border border-orange-100 rounded-2xl px-5 py-4">

          <div>

            <p className="font-semibold text-orange-700">
              Rental Extensions
            </p>

            <p className="text-xs text-orange-500 mt-1">
              Extra rental amount added
            </p>

          </div>

          <h3 className="text-xl font-bold text-orange-700">
            -₹{totalExtensions}
          </h3>

        </div>

      )}
     
{/* ADDED PRODUCTS */}

{Number(breakdown.totalAddedProductRent || 0) > 0 && (

  <div className="flex justify-between items-center bg-red-50 border border-red-100 rounded-2xl px-5 py-4">

    <div>

      <p className="font-semibold text-red-700">
        Added Product Charges
      </p>

      <p className="text-xs text-red-500 mt-1">
        Extra products added after booking
      </p>

    </div>

    <h3 className="text-xl font-bold text-red-700">
      -₹{breakdown.totalAddedProductRent}
    </h3>

  </div>

)}

{/* ADDED TRANSPORT */}

{Number(breakdown.totalAddedTransport || 0) > 0 && (

  <div className="flex justify-between items-center bg-red-50 border border-red-100 rounded-2xl px-5 py-4">

    <div>

      <p className="font-semibold text-red-700">
        Added Transport Charges
      </p>

    </div>

    <h3 className="text-xl font-bold text-red-700">
      -₹{breakdown.totalAddedTransport}
    </h3>

  </div>

)}

{/* ADDED LABOUR */}

{Number(breakdown.totalAddedLabour || 0) > 0 && (

  <div className="flex justify-between items-center bg-red-50 border border-red-100 rounded-2xl px-5 py-4">

    <div>

      <p className="font-semibold text-red-700">
        Added Labour Charges
      </p>

    </div>

    <h3 className="text-xl font-bold text-red-700">
      -₹{breakdown.totalAddedLabour}
    </h3>

  </div>

)}

{/* ADDITIONAL CHARGES */}

{Number(breakdown.totalAdditionalCharges || 0) > 0 && (

  <div className="flex justify-between items-center bg-red-50 border border-red-100 rounded-2xl px-5 py-4">

    <div>

      <p className="font-semibold text-red-700">
        Additional Charges
      </p>

      <p className="text-xs text-red-500 mt-1">
        Other manually added charges
      </p>

    </div>

    <h3 className="text-xl font-bold text-red-700">
      -₹{breakdown.totalAdditionalCharges}
    </h3>

  </div>

)}

      {/* LOST */}

      {Number(r.lost_charges || 0) > 0 && (

        <div className="flex justify-between items-center bg-red-50 border border-red-100 rounded-2xl px-5 py-4">

          <div>

            <p className="font-semibold text-red-700">
              Lost Product Charges
            </p>

            <p className="text-xs text-red-500 mt-1">
              Deducted from deposit
            </p>

          </div>

          <h3 className="text-xl font-bold text-red-700">
            -₹{r.lost_charges || 0}
          </h3>

        </div>

      )}

      {/* DAMAGE */}

      {Number(r.damage_charges || 0) > 0 && (

        <div className="flex justify-between items-center bg-red-50 border border-red-100 rounded-2xl px-5 py-4">

          <div>

            <p className="font-semibold text-red-700">
              Damage Charges
            </p>

            <p className="text-xs text-red-500 mt-1">
              Repair/damage deductions
            </p>

          </div>

          <h3 className="text-xl font-bold text-red-700">
            -₹{r.damage_charges || 0}
          </h3>

        </div>

      )}

    </div>

    {/* FINAL */}

    <div className={`rounded-3xl p-6 border-2

      ${
        settlementAmount > 0

          ? "bg-green-50 border-green-200"

          : settlementAmount < 0

          ? "bg-red-50 border-red-200"

          : "bg-gray-50 border-gray-200"
      }
    `}>

      {settlementAmount > 0 ? (

        <>

          <p className="text-sm font-medium text-green-600 uppercase tracking-wide">
            Refund Amount
          </p>

          <h2 className="text-4xl font-bold text-green-700 mt-2">
            ₹{settlementAmount}
          </h2>

          <p className="text-sm text-green-600 mt-2">
            Amount to be refunded to customer
          </p>

        </>

      ) : settlementAmount < 0 ? (

        <>

          <p className="text-sm font-medium text-red-600 uppercase tracking-wide">
            Customer Pays Extra
          </p>

          <h2 className="text-4xl font-bold text-red-700 mt-2">
            ₹{Math.abs(settlementAmount)}
          </h2>

          <p className="text-sm text-red-600 mt-2">
            Charges exceeded refundable deposit
          </p>

        </>

      ) : (

        <>

          <p className="text-sm font-medium text-gray-600 uppercase tracking-wide">
            Settlement Complete
          </p>

          <h2 className="text-3xl font-bold text-gray-700 mt-2">
            ₹0
          </h2>

          <p className="text-sm text-gray-500 mt-2">
            No pending refund/payment
          </p>

        </>

      )}

    </div>
{/* DISCOUNT */}

{totalDiscount > 0 && (

  <div className="flex justify-between items-center bg-green-50 border border-green-100 rounded-2xl px-5 py-4">

    <div>

      <p className="font-semibold text-green-700">
        Discount
      </p>

      <p className="text-xs text-green-500 mt-1">
        Discount applied
      </p>

    </div>

    <h3 className="text-xl font-bold text-green-700">
      ₹{totalDiscount}
    </h3>

  </div>

)}
    {/* REFUND */}

    {settlementAmount > 0 && (

     isSettled ? (

        <div className="bg-green-100 border border-green-300 text-green-700 px-5 py-4 rounded-2xl">

          <p className="font-semibold">
            Refund Completed
          </p>

          <p className="text-sm mt-1">
            Amount Refunded:
            {" "}
            ₹{r.deposit_returned || 0}
          </p>

        </div>

      ) : (

        <div className="space-y-4">

          <div>
            <label className="text-sm text-gray-500 block mb-2">
              Refund Amount
            </label>
            <input
              type="number"

             disabled={isSettled}

              placeholder="Enter refunded amount"

    value={returnedAmount}
              onChange={(e) =>
                setReturnedAmount(
                  e.target.value
                )
              }

              className="w-full border border-gray-200 bg-gray-50 rounded-2xl px-5 py-4 outline-none focus:ring-2 focus:ring-green-500"
            />
          </div>

          <div>
            <label className="text-sm text-gray-500 block mb-2">
              Settlement Note
            </label>
            <input
              type="text"

              disabled={isSettled}

              placeholder="Reason / details (optional)"

              value={settlementNote}

              onChange={(e) =>
                setSettlementNote(
                  e.target.value
                )
              }

              className="w-full border border-gray-200 bg-gray-50 rounded-2xl px-5 py-4 outline-none focus:ring-2 focus:ring-green-500"
            />
          </div>

          <button
            disabled={isSettled}

            onClick={handleSettlement}

            className="w-full bg-gradient-to-r from-green-600 to-emerald-600 text-white py-4 rounded-2xl font-semibold hover:shadow-lg disabled:opacity-50"
          >

            Confirm Refund

          </button>

        </div>

      )
    )}

    {/* EXTRA PAYMENT */}

    {settlementAmount < 0 && (

  isSettled ? ( 

        <div className="bg-red-100 border border-red-300 text-red-700 px-5 py-4 rounded-2xl">

          <p className="font-semibold">
            Payment Received
          </p>

          <p className="text-sm mt-1">
            Amount Received:
            {" "}
            ₹{r.extra_received || 0}
          </p>

        </div>

      ) : (

        <div className="space-y-4">

          <input
  type="number"

  disabled={isSettled}

  placeholder="Enter received amount"

           value={receivedAmount}

            onChange={(e) =>
              setReceivedAmount(
                e.target.value
              )
            }

            className="w-full border border-gray-200 bg-gray-50 rounded-2xl px-5 py-4 outline-none focus:ring-2 focus:ring-red-500"
          />

          <div>
            <label className="text-sm text-gray-500 block mb-2">
              Settlement Note
            </label>
            <input
  type="text"

  disabled={isSettled}

  placeholder="Reason / details (optional)"

              value={settlementNote}

              onChange={(e) =>
                setSettlementNote(
                  e.target.value
                )
              }

              className="w-full border border-gray-200 bg-gray-50 rounded-2xl px-5 py-4 outline-none focus:ring-2 focus:ring-red-500"
            />
          </div>

          <button
  disabled={isSettled}

  onClick={handleSettlement}

            className="w-full bg-gradient-to-r from-red-600 to-rose-600 text-white py-4 rounded-2xl font-semibold hover:shadow-lg disabled:opacity-50"
          >

            Confirm Payment

          </button>

        </div>

      )
    )}

  </div>

)}

 
          {/* CREDIT PAYMENTS */}

{activeTab === "settlement" && isCreditCustomer && (

  <div className="bg-white rounded-[32px] border border-gray-100 shadow-sm p-8 space-y-6">

    <div>

      <h2 className="text-2xl font-bold text-gray-800">
        Credit Payments
      </h2>

      <p className="text-sm text-gray-500 mt-1">
        Live bill & payment tracking
      </p>

    </div>

    {/* BREAKDOWN */}

    <div className="space-y-4">
      <div className="flex justify-between items-center bg-indigo-50 border border-indigo-100 rounded-2xl px-5 py-4">

<div>

<p className="font-semibold text-indigo-700">
Initial Rent
</p>

</div>

<h3 className="text-xl font-bold text-indigo-700">
₹{r.original_rental_amount || r.total_amount || 0}
</h3>

</div>
{totalExtensions > 0 && (

<div className="flex justify-between items-center bg-green-50 border border-green-100 rounded-2xl px-5 py-4">

<div>

<p className="font-semibold text-green-700">
Rental Extensions
</p>

</div>

<h3 className="text-xl font-bold text-green-700">
+₹{totalExtensions}
</h3>

</div>

)}
{totalReductions > 0 && (

<div className="flex justify-between items-center bg-orange-50 border border-orange-100 rounded-2xl px-5 py-4">

<div>

<p className="font-semibold text-orange-700">
Rental Reductions
</p>

</div>

<h3 className="text-xl font-bold text-orange-700">
-₹{totalReductions}
</h3>

</div>

)}
{Number(breakdown.totalAddedProductRent || 0) > 0 && (

<div className="flex justify-between items-center bg-red-50 border border-red-100 rounded-2xl px-5 py-4">

<div>

<p className="font-semibold text-red-700">
Added Product Charges
</p>

</div>

<h3 className="text-xl font-bold text-red-700">
-₹{breakdown.totalAddedProductRent}
</h3>

</div>

)}
{Number(breakdown.totalAddedTransport || 0) > 0 && (

<div className="flex justify-between items-center bg-red-50 border border-red-100 rounded-2xl px-5 py-4">

<div>

<p className="font-semibold text-red-700">
Added Transport Charges
</p>

</div>

<h3 className="text-xl font-bold text-red-700">
-₹{breakdown.totalAddedTransport}
</h3>

</div>

)}
{Number(breakdown.totalAddedLabour || 0) > 0 && (

<div className="flex justify-between items-center bg-red-50 border border-red-100 rounded-2xl px-5 py-4">

<div>

<p className="font-semibold text-red-700">
Added Labour Charges
</p>

</div>

<h3 className="text-xl font-bold text-red-700">
-₹{breakdown.totalAddedLabour}
</h3>

</div>

)}
{Number(breakdown.totalAdditionalCharges || 0) > 0 && (

<div className="flex justify-between items-center bg-red-50 border border-red-100 rounded-2xl px-5 py-4">

<div>

<p className="font-semibold text-red-700">
Additional Charges
</p>

</div>

<h3 className="text-xl font-bold text-red-700">
-₹{breakdown.totalAdditionalCharges}
</h3>

</div>

)}

{Number(r.lost_charges || 0) > 0 && (

<div className="flex justify-between items-center bg-red-50 border border-red-100 rounded-2xl px-5 py-4">

<div>

<p className="font-semibold text-red-700">
Lost Product Charges
</p>

</div>

<h3 className="text-xl font-bold text-red-700">
-₹{r.lost_charges}
</h3>

</div>

)}
{Number(r.damage_charges || 0) > 0 && (

<div className="flex justify-between items-center bg-red-50 border border-red-100 rounded-2xl px-5 py-4">

<div>

<p className="font-semibold text-red-700">
Damage Charges
</p>

</div>

<h3 className="text-xl font-bold text-red-700">
-₹{r.damage_charges}
</h3>

</div>

)}


      

    </div>


    {/* PAID / PENDING SUMMARY */}

    <div className="grid grid-cols-2 gap-4">

      <div className="bg-green-50 border border-green-100 rounded-2xl p-4">
        <p className="text-sm text-gray-500">
          Paid Amount
        </p>
        <h3 className="text-2xl font-bold text-green-600 mt-1">
          ₹{paidAmount}
        </h3>
      </div>

      <div className="bg-red-50 border border-red-100 rounded-2xl p-4">
        <p className="text-sm text-gray-500">
          Pending Amount
        </p>
        <h3 className="text-2xl font-bold text-red-600 mt-1">
          ₹{pendingAmount}
        </h3>
      </div>

    </div>
    {totalDiscount > 0 && (

<div className="flex justify-between items-center bg-green-50 border border-green-100 rounded-2xl px-5 py-4">

<div>

<p className="font-semibold text-green-700">
Discount
</p>

</div>

<h3 className="text-xl font-bold text-green-700">
+₹{totalDiscount}
</h3>

</div>

)}

    {/* COLLECT PAYMENT */}

    {pendingAmount > 0 && (

      <div className="space-y-4">

        <input
          type="number"

          placeholder="Collect Amount"

          value={creditAmount}

          onChange={(e) =>
            setCreditAmount(
              e.target.value
            )
          }

          className="w-full border border-gray-200 bg-gray-50 rounded-2xl px-5 py-4 outline-none focus:ring-2 focus:ring-green-500"
        />

        <input
          type="text"

          placeholder="Payment Note"

          value={paymentNote}

          onChange={(e) =>
            setPaymentNote(
              e.target.value
            )
          }

          className="w-full border border-gray-200 bg-gray-50 rounded-2xl px-5 py-4 outline-none focus:ring-2 focus:ring-green-500"
        />

        <button
          onClick={handleCollectPayment}

          className="w-full bg-gradient-to-r from-green-600 to-emerald-600 text-white py-4 rounded-2xl font-semibold hover:shadow-lg transition-all"
        >

          Collect Payment

        </button>

      </div>

    )}

  </div>

)}
{/* LOST PRODUCT RECOVERY REFUNDS */}

{activeTab === "settlement" &&
(
    (!isCreditCustomer && isSettled) ||
    (
        isCreditCustomer &&
        Number(r.pending_amount || 0) === 0
    )
) &&
recoveryRefunds.length > 0 && (

<div className="bg-white rounded-[32px] border border-gray-100 shadow-sm p-8 space-y-5">

<h2 className="text-2xl font-bold">
Lost Product Recovery Refunds
</h2>

<p className="text-gray-500 text-sm">
These products were returned after settlement.
Refund them separately.
</p>

{recoveryRefunds.map(refund=>(

<div
key={refund.id}
className="border rounded-2xl p-5 bg-gray-50 space-y-4"
>

<div className="flex justify-between">

<div>

<h3 className="font-semibold">
{refund.product_name}
</h3>

<p className="text-sm text-gray-500">

Recovered Qty :
{refund.recovered_quantity}

</p>

<p className="text-sm text-gray-500">

Recovered On :
{formatDate(refund.recovered_date)}

</p>

</div>

<div className="text-right">

<p className="text-sm text-gray-500">

Refund

</p>

<h2 className="text-2xl font-bold text-green-600">

₹{refund.amount}

</h2>

</div>

</div>

{refund.paid ? (

<div className="bg-green-100 border border-green-300 rounded-xl px-4 py-3">

  <p className="font-semibold text-green-700">
    Refund Paid
  </p>

  <p className="text-sm text-green-600 mt-1">
    ₹{refund.amount}
  </p>

  <p className="text-xs text-gray-500 mt-1">
    {formatDate(refund.paid_date)}
  </p>

</div>

) : (

<button

onClick={() =>
  handlePayRecoveryRefund(refund)
}

className="bg-green-600 text-white px-5 py-3 rounded-xl hover:bg-green-700"

>

Pay Refund

</button>

)}

</div>

))}

</div>

)}
          {/* PAYMENT HISTORY */}

          {activeTab === "settlement" && isCreditCustomer && (

            <div className="bg-white p-6 rounded shadow-sm">

              <h2 className="font-semibold text-lg mb-4">
                Payment History
              </h2>

              <div className="space-y-3">

                {paymentHistory.map((p, i) => (

                  <div
                    key={i}
                    className="border rounded p-3 text-sm"
                  >

                    <div className="flex justify-between">

                      <p className="font-semibold text-green-600">
                        ₹{p.amount}
                      </p>

                      <p className="text-xs text-gray-500">
                        {formatDate(
                          p.payment_date
                        )}
                      </p>

                    </div>

                    <p className="text-xs text-gray-500 mt-1">
                      {p.note || "No note"}
                    </p>

                  </div>

                ))}

              </div>

            </div>

          )}

        </div>

      </div>

    </div>
  );
};

export default RentalDetail;